module.exports = __webpack_public_path__ + "img/buyHomeMask.579a0ee7.png";